import { defineComponent as _defineComponent } from 'vue'
import { toRef } from "@nuxtjs/composition-api";

import { useCategory, useLinkService } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryItem',
  props: {
  categoryName: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: "60",
  },
  column: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const linkService = useLinkService();

/**
 * Gets the category data from the store.
 */
const { displayName, image } = useCategory(toRef(props, "categoryName"));

const imageSrc =
  linkService.getImageLink({
    url: image.value,
    width: props.size,
    height: props.size,
  }) ?? "";

return { __sfc: true,props, linkService, displayName, image, imageSrc }
}

})